import { client } from '../common/client';
import type { ListTrendingVideosRequest, ListTrendingVideosResponse, TrendingVideoItem } from './utils/types';

class TrendingVideoAPIClient {
  public async list(params?: ListTrendingVideosRequest) {
    return await client.get<ListTrendingVideosResponse>('/trendingVideos', { params }).then((res) => res.data);
  }

  public async get(videoId: string) {
    return await client.get<TrendingVideoItem>(`/trendingVideos/${videoId}`).then((res) => res.data);
  }
}

export const trendingVideoAPIClient = new TrendingVideoAPIClient();
